import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const PGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="PG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Rect width={16} height={12} fill="#E11C1B" rx={1} />
      <Path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="m0 0 16 12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#EEEEF6"
        fillRule="evenodd"
        d="M3.542 9.134h.666l.316-.746.372.741.683.038-.583.634.299.765-.741-.426-.684.43.258-.743-.586-.693ZM1.542 7.134h.666l.316-.746.372.741.683.038-.583.634.299.765-.741-.426-.684.43.258-.743-.586-.693ZM3.542 6.134h.666l.316-.746.372.741.683.038-.583.634.299.765-.741-.426-.684.43.258-.743-.586-.693Z"
        clipRule="evenodd"
      />
      <Path
        fill="#EEEEF6"
        fillRule="evenodd"
        d="m4.856 8.282.457-.015.166-.472.185.47.421.04-.379.268.306.475-.53-.198-.46.204.242-.468-.408-.304ZM5.856 7.282l.457-.015.166-.472.185.47.421.04-.379.268.306.475-.53-.199-.46.205.242-.468-.408-.304Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M10.542 1s-1.545.308-1.111 2.455h-.22s.018-.112-.194-.178c-.212-.065-.17-.04-.279 0-.11.041-.774 0-.774 0v.082l.47.204s-.011.169.185.263c.197.093.34.139.34.139s.03.186-.155.186-.926-.24-1.19.35C7.35 5.093 7 5.526 7 5.526h.395l-.106.132h.446l-.12.069s.55-.006.593-.069c.043-.062 0 .169 0 .169s.534-.244.563-.3l.249.17.07-.289.268.118.073-.275s.756 1.264 1.33 1.192v-.21l.523.21.066-.094s.632.258.827.282l-.139-.282h.139l-.139-.522h.139l-.278-.419.078-.113-.052-.15s1.018.325.972.84c-.046.517-.499.725-.499.725s-.434.133-.827.104c0 0 .312.368.971.244.66-.125.878-.764.878-.764s.302.628.053.958c-.249.33-1.357.562-1.357.562s.401.235.781.175.972-.391 1.086-.931c.115-.54-.395-1.536-.626-1.65l-.091-.345.207.083-.426-1.042.207.045-.603-.75.166-.051-.833-.6.25-.065s-.617-.312-1.32.066l.008-.13-.185.03.01-.143.184-.278-.275-.106s.223-.335.19-.33c0 0-.249.071-.235.041 0 0 .125-.322.092-.313 0 0-.287.097-.245.048l.11-.196L10.543 1Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
